import React from 'react';

// eslint-disable-next-line max-len
const BROADWAY_LOGO = '/themes/theme/broadway/logo.png';
const BROADWAY_FULL_LOGO = '/themes/theme/broadway/logo-full.png';

const BroadwayTheme = {
  headerLogo: {
    src: BROADWAY_LOGO,
    alt: 'Broadway Logo',
    size: 75,
  },
  darkLogo: {
    src: BROADWAY_LOGO,
    alt: 'Broadway Logo',
    size: 75,
  },
  linkStyle: {
    color: '#305fab',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #d472c3',
    height: 80,
  },
  title: 'Broadway',
  organisationId: 'd1121be5-13d3-4f5a-82ff-6e49557d40c2',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="100"
        src={BROADWAY_FULL_LOGO} alt="Broadway Logo"
      />
      <br /><br />
      {/* <h3>FLYT</h3> */}
    </div>
  ),
  shareSite: 'https://reports.broadwaysocial.media',
};

export default BroadwayTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/broadway.js
 **/